import React from 'react';
export function Hero() {
  return <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-142">
      {/* Parallax Background — mobile centers the dog (~35% from left, no bg-fixed
                since background-attachment:fixed is unreliable on mobile and mis-frames
                the subject). Parallax/fixed only kicks in at md+. */}
      <div className="absolute inset-0 z-0 bg-cover bg-no-repeat scale-105 bg-[position:35%_center] md:bg-[position:center_30%] md:bg-fixed" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/6BLsetZLworkx7G3rPtADU/valley-hero.jpg")'
    }} data-id="element-143" />

      {/* Dark Overlay — heavier at top (nav) and bottom (text), lets center subject breathe */}
      <div className="absolute inset-0 z-10" style={{
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.55) 40%, rgba(0,0,0,0.80) 100%)'
    }} data-id="element-144" />

      {/* Radial vignette — darkens edges and draws the eye to the dog and text */}
      <div className="absolute inset-0 z-10" style={{
      background: 'radial-gradient(ellipse at center, transparent 20%, rgba(0,0,0,0.65) 100%)'
    }} data-id="element-145" />

      {/* Content */}
      <div className="relative z-20 container mx-auto px-6 md:px-12 text-center flex flex-col items-center mt-16" data-id="element-146">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading text-brand-light mb-6 leading-tight" style={{
        textShadow: '0 2px 20px rgba(0,0,0,0.8), 0 0 40px rgba(0,0,0,0.5)'
      }} data-id="element-147">
          Sit. Stay. <br className="md:hidden" data-id="element-148" />
          <span className="text-brand-orange" data-id="element-149">We Come to You.</span>
        </h1>

        <p className="text-lg md:text-xl text-brand-light max-w-2xl mx-auto mb-10 font-medium" style={{
        textShadow: '0 1px 8px rgba(0,0,0,0.9)'
      }} data-id="element-150">
          Luxury mobile grooming + our brand-new Goodyear salon.{' '}
          <br className="hidden md:block" data-id="element-151" />
          <span className="text-brand-pink" data-id="element-152">
            Stress-free. Cage-free. Chemicals-free.
          </span>
        </p>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto items-center justify-center mb-12" data-id="element-153">
          <a href="#book" className="bg-brand-orange text-brand-light px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-600 hover:box-glow transition-all duration-300 w-full sm:w-auto min-h-[48px] flex items-center justify-center" data-id="element-154">
            Request a Quote
          </a>
          <a href="tel:6028882209" className="bg-transparent border-2 border-brand-light text-brand-light px-8 py-4 rounded-full font-semibold text-lg hover:bg-brand-light hover:text-brand-dark transition-all duration-300 w-full sm:w-auto min-h-[48px] flex items-center justify-center" data-id="element-155">
            Call (602) 888-2209
          </a>
        </div>

        <p className="text-sm md:text-base text-brand-light/80 tracking-wide uppercase font-medium" style={{
        textShadow: '0 1px 8px rgba(0,0,0,0.9)'
      }} data-id="element-156">
          Serving Buckeye, Goodyear, Avondale, Surprise, Peoria, Glendale & West
          Phoenix
        </p>
      </div>
    </section>;
}